'use client';

import styled from 'styled-components';

import { Flex, Spacing, Skeleton } from '@zoomit/primitives';
import { elevation, theme } from '@zoomit/zoomit-ds';

export const ProductStoreListItemMobileSkeleton = () => {
  return (
    <Root className="bg-background2">
      <Flex gap={Spacing.x4} flexDirection="column" alignItems="center" justifyContent="space-between">
        <Flex className="w-full" flexDirection="column" gap={Spacing.x4}>
          <RoundedSkeleton variant="rectangular" width={8} height={8} radius={4} />
          <Flex flexDirection="column" spacing={{ py: 'x3' }} gap={Spacing.x4} justifyContent="center">
            <Skeleton variant="text" width={11} />
            <Skeleton variant="text" width={20} />
          </Flex>
        </Flex>
        <Flex className="w-full" gap={Spacing.x2} justifyContent="space-around" alignItems="center">
          <RoundedSkeleton width={15} height={2.4} radius={12} />
          <RoundedSkeleton width={15} height={2.4} radius={12} />
        </Flex>
      </Flex>
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  padding: 1.6rem;
  border-radius: var(${theme.radius.sm});
  ${elevation};
`;

const RoundedSkeleton = styled(Skeleton)<{ radius: number }>`
  border-radius: ${({ radius }) => `${radius}px`};
`;
